import { Fragment, useState } from "react";
import DataTable, { SortButton } from "../../../shared/components/DataTable";
import Card from "../../../shared/components/Card";
import Form from "../../../shared/components/Form";
import {
  useTableSearch,
  useTableSort,
} from "../../../shared/components/DataTable";
// import ResourceLink from "../../../shared/components/ResourceLink";

export default function ProductsTable({
  products,
  onAddClick,
  onProductClick,
}) {
  const columns = [
    {
      text: "Produit #",
      dataField: "sku",
      style: { padding: 0 },
      formatter: (_cell, row, _rowIndex, _idk) => (
        // console.log("product", row["name"])
        <div onClick={onProductClick(row.id)}>
          <label> {row["name"]}</label></div>
        // <div onClick={onProductClick(row.id)}>
        //   <ResourceLink
        //     resourceIdentifier={row.productCode}
        //     resourceName={row.name}
        //   />
        // </div>
      ),
      sort: true,
    },
    {
      text: "Category",
      dataField: "category",
      style: { padding: 0 },
      // formatter: (_cell, row, _rowIndex, _idk) => (
      //   <ResourceLink
      //     to={`/products/${row.category?.id}`}
      //     resourceIdentifier={row.category?.id}
      //     resourceName={row.category?.id}
      //   />
      // ),
      sort: true,
    },
  ];

  const sortConfig = [
    {
      text: "Code",
      sort: { dataField: "code", order: "asc" },
    },
    {
      text: "Nom",
      sort: { dataField: "name", order: "asc" },
    },
    {
      text: "Date de création",
      sort: null,
    },
    {
      text: "Date de modification",
      sort: null,
    },
  ];
  const { onChange, filteredData } = useTableSearch(products);
  const { changeSortOrder, sortInfo, setSortInfo } = useTableSort();
  const [sortingDropdown, setSortingDropdown] = useState(false);

  return (
    <>
      <Card>
        <Card.Header>
          <div className="row">
            <div className="col-2">
              <Form.Input
                onChange={onChange("code")}
                size="sm"
                placeholder="Code produit..."
              />
            </div>
            <div className="col-2">
              <Form.Input
                onChange={onChange("name")}
                size="sm"
                placeholder="Nom produit ..."
              />
            </div>
            <br style={{ marginLeft: "auto" }} />
            <SortButton
              changeSortOrder={changeSortOrder}
              sortInfo={sortInfo}
              sortConfig={sortConfig}
              showDropdown={sortingDropdown}
              setShowDropdown={setSortingDropdown}
              setSortInfo={setSortInfo}
            />
            <button onClick={onAddClick} className="btn btn-secondary ml-3">
              Ajouter
            </button>
          </div>
        </Card.Header>
        <Card.Body>
          <DataTable
            sort={sortInfo?.sort}
            columns={columns}
            data={filteredData}
          />
        </Card.Body>
      </Card>
    </>
  );
}
